/**
 * Connect step route (CLA-453) — eagerly registers the file route and its
 * `?step=` search validator; the step component and its atom/RPC imports are
 * deferred to `connect.lazy.tsx` so they load only with this route, never in the
 * always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { isConnectSubStepId, type OnboardingConnectSubStepId } from "~/lib/onboarding-steps.ts";

/**
 * Validate the `?step=` search param carrying the active sub-step. The
 * sub-step lives in the URL — OAuth round-trips are full page loads, so any
 * in-memory position would reset to Codex on return (and reloads / resume
 * links would lose their place the same way).
 *
 * @since 1.0.0
 */
export const validateConnectSearch = (
  search: Record<string, unknown>,
): { step?: OnboardingConnectSubStepId } => isConnectSubStepId(search["step"]) ? { step: search["step"] } : {};

export const Route = createFileRoute("/clawinstall/onboarding/connect")({
  validateSearch: validateConnectSearch,
});
